/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_No_Gps_DataInputs */

const vi_tracking_no_gps_data = /** @type {(inputs: Tracking_No_Gps_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu GPS`)
};

/**

* @param {Tracking_No_Gps_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_no_gps_data = /** @type {((inputs?: Tracking_No_Gps_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_No_Gps_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_no_gps_data(inputs)
});